function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import c from 'classnames';
const IconButton = props => {
  const {
    children,
    icon,
    href,
    variant,
    small,
    simple,
    disabled
  } = props;
  const classNames = c('icon-button', 'icon-after', {
    simple,
    small,
    'no-styling': !href,
    ["icon-".concat(icon)]: icon,
    ...(variant && {
      ["icon-variant-".concat(variant)]: variant
    })
  });
  if (href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      className: classNames
    }, children);
  }
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    "aria-disabled": disabled,
    type: "button",
    className: classNames
  }), children);
};
export default IconButton;